import { Component, Input, OnInit } from '@angular/core';
import {  ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-registration-configuration-reorder',
  templateUrl: './registration-configuration-reorder.component.html',
  styleUrls: ['./registration-configuration-reorder.component.scss']
})
export class RegistrationConfigurationReorderComponent {
  @Input() public Content: any;
  content:any;
  ListOfControls:any=[];
  action: Subject<any> = new Subject();
  ChangesHappend:boolean=false;
  constructor(
    public modalRef: NgbActiveModal,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService:CommonService
  ) {
    
  }
  ngOnInit() {
    
    this.ListOfControls=this.Content.content.Data;
  }
  SaveOrder()
  {    
    if(this.ChangesHappend)
    this.modalRef.close(this.ListOfControls); 
  else 
  this.modalRef.dismiss();
  }
  Close()
  {
    this.canExit().then(x=>{
     this.modalRef.dismiss();
    });
 }
  listSorted(event:any){
   this.ChangesHappend=true;
  }

  canExit() {
    if (this.ChangesHappend) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

}

